<template>
  <div>
    <vue-headful :title="meta_title" description="Description goes here" />
    <div class="student-profile-section base-type-layout">
      <div v-if="!fetchingPosts">
        <!-- BREADCRUMB -->
        <BreadCrumb
          :item_one="current_class_name"
          item_three="Post Details"
          item_two="Feeds"
          :item_two_link="route_link"
          :route_name="student_profile_route"
          :show_nav="false"
        />

        <!-- STUDENTS PROFILE CONTAINER -->
        <div
          class="container px-1 student-container"
          style="margin-bottom: 90px"
        >
          <div class="row">
            <!-- PROFILE CARD -->
            <div class="col-12 col-md-4 col-lg-3 col-xl-3 left-layout">
              <StudentProfileCard
                :child_img="student_image"
                :child_name="student_name"
                :class_code="student_code"
                :parent_name="parent_name"
                :parent_role="parent_role"
                :parent_count="parent_count"
                card_type="school"
              ></StudentProfileCard>
            </div>

            <!-- PROFILE DETAILS -->
            <div class="col-12 col-md-8 col-lg-7 col-xl-6">
              <!-- PROFILE INTRO DETAILS -->
              <div>
                <!-- POST VIEW COMPONENT -->
                <div class="right-layout" v-if="post_data">
                  <!-- POST COMPONENT -->
                  <PostBlock
                    :posts="post_data"
                    :subscription_status="subscription_status"
                  ></PostBlock>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <SectionLoader
      :loader_text="'Fetching post details'"
      v-if="fetchingPosts"
    ></SectionLoader>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { randomString } from "@/scripts/utilities";
import BreadCrumb from "@/components/globalComps/BreadCrumb";
import PostBlock from "@/components/classComps/feeds/PostBlock";
import StudentProfileCard from "@/components/profileComps/studentprofile/StudentProfileCard";
import SectionLoader from "@/components/globalComps/SectionLoader";

export default {
  name: "PostDetails",

  props: {
    post_id: Number,
  },

  components: {
    BreadCrumb,
    PostBlock,
    StudentProfileCard,
    SectionLoader,
  },

  data() {
    return {
      account_type: this.$route.path.split("/")[1],
      fetchingPosts: true,
      post_data: [],
      subscription_status: true,

      student_id: null,
      post_token: null,
      current_class_name: "Class name here...",
      route_link: "",
      route_link_three: "",
      student_profile_route: "",
      students_list: "",
      route_list_length: "",

      parent_count: 0,
      parent_role: "",
      parent_name: "",
      student_code: "Class code...",
      student_name: "Student Name",
      student_image: "",

      user_name: "",
      user_image: "",
    };
  },

  watch: {
    $route: {
      handler() {
        this.fetchPost();
      },
      immediate: true,
    },
  },

  computed: {
    ...mapGetters(["getAuthUser", "getCurrentClass", "getSelectedChildID"]),

    meta_title() {
      return `${this.student_name.toUpperCase()} | Feed Details`;
    },

    getPostType() {
      // POST HAS EITHER IMAGE
      const has_image = this.post_obj.attachments.some(
        (attachment) => attachment.filetype == "image"
      );

      // POST HAS EITHER VIDEO
      const has_video = this.post_obj.attachments.some(
        (attachment) => attachment.filetype == "video"
      );

      // POST HAS EITHER DOCUMENT
      const has_document = this.post_obj.attachments.some(
        (attachment) => attachment.filetype == "document"
      );

      if (this.post_obj.type === "homework") return "PostHomeworkBlock";
      if (this.post_obj.type === "live_class") return "PostEventBlock";
      if (this.post_obj.type === "lesson") return "PostLessonBlock";

      if (has_image) return "PostImageBlock";
      if (has_video) return "PostVideoBlock";
      if (has_document) return "PostDocumentBlock";
      else return false;
    },
  },

  created() {
    if (this.account_type === "school") this.route_link = "ClassFeeds";
    if (this.account_type === "teacher") this.route_link = "TeacherFeeds";
    if (this.account_type === "parent") this.route_link = "ParentFeeds";
    if (this.account_type === "student") this.route_link = "StudentFeeds";

    if (this.$route.params.token) {
      this.post_token = this.$route.params.token;
      this.user_name = this.getAuthUser.full_name;
      this.user_image = this.getAuthUser.image;
    } else
      this.$router.push({
        name: this.route_link,
      });
  },

  mounted() {
    this.fetchPost();
  },

  methods: {
    ...mapActions([
      "getSchoolStudentFeedDetails",
      "getSubscriptionPaymentStatus",
    ]),

    async callPaymentStatus(child_id = 0, class_id = 0) {
      this.getSubscriptionPaymentStatus({ child_id, class_id })
        .then((response) => {
          // console.log("response >> ", response);
          this.subscription_status =
            this.account_type === "parent" || this.account_type === "student"
              ? true || response.data.lms
              : true || response.data.status;
        })
        .catch((err) => console.log(err));
    },

    generateId(id) {
      return `${randomString(11)}${id}`;
    },

    fetchPost() {
      let data = {
        token: this.post_token,
        class_id: this.$route.query.class_id || this.getCurrentClass,
        id: this.getSelectedChildID,
      };

      // console.log("Data", data);

      this.getSchoolStudentFeedDetails(data)
        .then(async (query) => {
          this.fetchingPosts = false;
          // console.log("Response", query);
          let res = query.data;

          this.student_name = `${res.user.firstname} ${res.user.lastname}`;
          this.student_code = res.user.code.toUpperCase();
          this.student_image = res.user.image;
          this.student_id = res.user.id;

          this.post_data = [query.data];

          this.current_class_name = res.class.class_name;

          this.account_type === "parent" || this.account_type === "student"
            ? await this.callPaymentStatus(res.user.id)
            : await this.callPaymentStatus(0, this.getCurrentClass);
        })
        .catch((err) => {
          this.fetchingPosts = false;
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss">
.class-feed-view {
  top: 100px;

  .right-layout {
    @include breakpoint_max(md) {
      margin-bottom: 80px;
    }
  }
}

.go-back-post {
  margin-bottom: 16px;
  transition: all 0.3s ease-in-out;

  @include breakpoint_max(sm) {
    .icon {
      font-size: 20px !important;
    }

    .text {
      font-size: 15.5px;
    }
  }

  &:hover {
    color: $border_grey_dark !important;
  }
}
</style>
